import { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";

// Admin Login Component with Password
const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API}/auth/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        onSuccess(data.user);
      } else {
        setError(data.detail || "Invalid password");
      }
    } catch (err) {
      setError("Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen quiet-luxury-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="glass rounded-sm p-10">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-[#C5A572]/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-[#C5A572]" />
            </div>
            <h1 className="font-serif text-3xl text-white mb-2">Admin Access</h1>
            <p className="text-silver/50 text-sm">
              Enter your administrator password
            </p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="w-full h-14 px-4 pr-12 bg-white/5 border border-white/10 text-white placeholder:text-white/30 focus:outline-none focus:border-[#C5A572]/50 text-base"
                autoFocus
                data-testid="admin-password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/60"
              >
                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>

            {error && (
              <div className="bg-red-500/10 border border-red-500/30 rounded-sm p-3">
                <p className="text-red-400 text-sm text-center">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !password}
              className="w-full py-4 bg-[#C5A572] text-black font-semibold tracking-wide text-sm uppercase hover:bg-[#D4B896] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="admin-login-btn"
            >
              {loading ? "Verifying..." : "Access Dashboard"}
            </button>
          </form>
          
          <p className="text-silver/30 text-xs mt-6 text-center">
            Ivarge LLC • Authorized Personnel Only
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
